<!-- ========== MAIN CONTENT ========== -->
<div id="login_screen" role="main" class="main">
  <!-- Content -->
  <div class="container-fluid">
    <div class="row">
      <!-- Login Left Side -->
      <div
        class="col-lg-6 col-md-7 col-sm-12 login_left min-vh-100 position-relative p-0"
      >
        <div class="w-100">
          <!-- Left Side Login Image -->
          <img
            class="w-100 vh-100 login_img"
            src="assets/images/login_left.png"
            alt="Covnia login img"
          />
          <!-- END Left Side Login Image -->
        </div>
      </div>
      <!-- End Login Left Side -->

      <!-- Login Right Side -->
      <div
        class="col-lg-6 col-md-5 col-sm-12 login_right d-flex justify-content-center align-items-center min-vh-lg-100 p-lg-4 p-sm-0"
      >
        <div class="w-70 py-5 p-xl-0 p-lg-4 p-md-0">
          <div class="mb-5">
            <!-- Right Side Company Logo -->
            <img
              class="img-fluid"
              id="login_main_logo"
              src="assets/images/main_logo.svg"
              alt="Company Logo"
            />
            <!-- END Right Side Company Logo -->
          </div>
          <div class="login_sec">
            <ng-container [ngTemplateOutlet]="displayTemplate"></ng-container>

            <!-- SHOW LOGIN FORM -->
            <ng-template #showLogin>
              <!-- Access Denied Error -->
              <div class="invalid-feedback help-block" *ngIf="showAccessDenied">
                <em class="bi-exclamation-triangle-fill"></em> This user doesn’t
                exist. Try another account or
                <a (click)="gethelp()" class="fw-bold text-secondary"
                  >Get Help?</a
                >
                instead.
              </div>
              <!-- END Access Denied Error -->

              <!-- Login form start -->
              <form
                id="login_form"
                [formGroup]="loginForm"
                (ngSubmit)="login(loginForm)"
              >
                <!-- Log In Form Tittle -->
                <div class="mb-4">
                  <h2 class="login_title">Login to your account</h2>
                </div>

                <!-- Email Form Group -->
                <label class="input-label" for="loginEmail"
                  >Email
                  <span class="text-danger" matTooltip="Password is mandatory"
                    >*</span
                  >
                </label>
                <div class="input-group">
                  <input
                    type="email"
                    formControlName="username"
                    class="form-control form-control-lg"
                    name="email"
                    id="loginEmail"
                    placeholder="Enter official email ID"
                    tabindex="1"
                    autocomplete="off"
                  />
                </div>

                <!-- Login email error -->
                <div id="loginEmail-error" class="invalid-feedback help-block">
                  <div
                    *ngIf="
                      loginFC['username'].touched || loginFC['username'].dirty
                    "
                  >
                    <ng-container
                      *ngIf="
                        loginFC['username'].value === '' ||
                          loginFC['username'].value === null;
                        else fnInvalid
                      "
                    >
                      Please enter official email ID.
                    </ng-container>

                    <ng-template #fnInvalid>
                      <span *ngIf="loginFC['username'].errors">
                        Please enter a valid email ID format(ex:
                        abc&#64;domain.com)
                      </span>
                    </ng-template>
                  </div>
                </div>
                <!-- End Login email error -->
                <!-- End Email Form Group -->

                <!-- Password Form Group -->
                <label class="input-label" for="login_pwd"
                  >Password
                  <span class="text-danger" matTooltip="Password is mandatory"
                    >*</span
                  ></label
                >
                <div class="input-group">
                  <input
                    formControlName="login_password"
                    [type]="showPassword ? 'text' : 'password'"
                    class="form-control form-control-lg"
                    placeholder="Enter your password"
                    name="password"
                    id="login_pwd"
                    tabindex="2"
                    autocomplete="off"
                  />
                  <div class="input-group-text changePassTarget">
                    <em
                      class="changePassIcon bi"
                      [ngClass]="{
                        'bi-eye-fill': !showPassword,
                        'bi-eye-slash-fill': showPassword
                      }"
                      (click)="showPassword = !showPassword"
                    >
                    </em>
                  </div>
                </div>

                <!-- Login password error -->
                <div
                  id="loginPassword-error"
                  class="invalid-feedback help-block"
                >
                  <div
                    *ngIf="
                      loginFC['login_password'].touched ||
                      loginFC['login_password'].dirty
                    "
                  >
                    <ng-container
                      *ngIf="
                        loginFC['login_password'].value === '' ||
                        loginFC['login_password'].value === null
                      "
                    >
                      Please enter valid password associated to above email ID
                    </ng-container>
                  </div>
                </div>
                <!-- End Login password error -->
                <!-- Password Form Group -->

                <!-- Forgot Password -->
                <div class="d-flex align-items-center justify-content-between">
                  <span
                    >Having troubles?<a class="text-primary"> Get Help? </a>
                  </span>
                  <a class="text-primary" (click)="forgotPassword()">
                    Forgot Password?</a
                  >
                </div>
                <!-- End Forgot Password -->

                <!-- Login button -->
                <button
                  class="btn btn-lg btn-block btn-primary my-2"
                  tabindex="5"
                  type="submit"
                  value="Login"
                  [ngStyle]="{
                    cursor:
                      loginForm.status !== 'VALID' ? 'not-allowed' : 'pointer'
                  }"
                  [disabled]="loginForm.invalid"
                >
                  Log In
                </button>
                <!-- End Login button -->
              </form>
              <!-- Login form END -->
            </ng-template>
            <!-- End SHOW LOGIN FORM -->

            <!-- SHOW FORGOT/RESET PASSWORD FORM -->
            <ng-template #showForgotPswd>
              <!-- Forgot Form Start -->
              <form
                class="forgot-password-fields"
                id="forgotpwd_form"
                [formGroup]="forgotForm"
                (ngSubmit)="forgotPswd(forgotForm)"
              >
                <div class="mb-4">
                  <h2 class="login_title">Reset Password</h2>
                  <p class="login_sub_title">
                    Please enter the email address you'd like your password
                    reset information sent to.
                  </p>
                </div>
                <!-- Forgot Email Form Group -->
                <label class="input-label" for="forgotEmail"
                  >Email ID
                  <span class="text-danger" matTooltip="Password is mandatory"
                    >*</span
                  >
                </label>
                <div class="input-group">
                  <span class="input-group-text">
                    <em class="bi bi-envelope-fill gd_icon"></em>
                  </span>
                  <input
                    type="email"
                    formControlName="username"
                    class="form-control form-control-lg"
                    name="email"
                    id="forgotEmail"
                    placeholder="Ex: yourname@companyname.com"
                    tabindex="1"
                    autocomplete="off"
                  />
                </div>
                <!-- End Forgot Email Form Group -->

                <!-- Forgot form email error -->
                <div id="forgotEmail-error" class="invalid-feedback help-block">
                  <div
                    *ngIf="fgtFC['username'].touched || fgtFC['username'].dirty"
                  >
                    <ng-container
                      *ngIf="
                        fgtFC['username'].value === '' ||
                          fgtFC['username'].value === null;
                        else fnInvalid
                      "
                    >
                      Please enter official email ID.
                    </ng-container>

                    <ng-template #fnInvalid>
                      <span *ngIf="fgtFC['username'].errors">
                        Please enter a valid business email ID format(ex:
                        abc&#64;domain.com)
                      </span>
                    </ng-template>
                  </div>
                </div>
                <!-- End Forgot form email error -->

                <!-- Reset Pwd Button -->
                <button
                  type="submit"
                  class="btn btn-lg btn-block btn-gradient mt-3"
                  [ngStyle]="{
                    cursor:
                      forgotForm.status !== 'VALID' ? 'not-allowed' : 'pointer'
                  }"
                  [disabled]="forgotForm.invalid"
                  (click)="resetPwdLink()"
                >
                  Get Reset Password Link
                </button>
                <!-- END Reset Pwd Button -->

                <!-- Go back to Log in Button -->
                <a
                  class="text-primary back_to_login"
                  (click)="GoToLoginFields()"
                >
                  <i class="bi bi-chevron-left fs-6"></i> Back to Login
                </a>
                <!-- END Go back to Log in Button -->
              </form>
              <!-- End Forgot Form Start -->
            </ng-template>
            <!-- End SHOW FORGOT/RESET PASSWORD FORM -->

            <!-- SHOW Reset pwd mail sent success -->
            <ng-template #showResetPwdLink>
              <!-- Forgot Form Start -->
              <div class="forgot-password-fields" id="forgotpwd_form">
                <div class="login-fields text-center">
                  <img
                    src="assets/img/mail_sent.svg"
                    alt="Reset Password Link Sent"
                  />
                  <h2 id="frgt_t" class="mb-1 pt-1">Check your mail</h2>
                  <p class="text-light">
                    We have sent you an email that contains a link to reset your
                    password
                  </p>

                  <!-- Go back to Log in Button -->
                  <a
                    class="btn btn-block mt-3 text-primary"
                    (click)="GoToLoginFields()"
                  >
                    <i class="bi bi-chevron-left fs-6"></i> Back to Login
                  </a>
                  <!-- END Go back to Log in Button -->
                </div>
              </div>
              <!-- End Forgot Form Start -->
            </ng-template>
            <!-- End SHOW Reset pwd mail sent success -->

            <!-- Show Project ID and Token based Login -->
            <ng-template #showTestLogin>
              <!-- Access Denied Error -->
              <div class="invalid-feedback help-block" *ngIf="showAccessDenied">
                <em class="bi-exclamation-triangle-fill"></em> This user doesn’t
                exist. Try another account or
                <a (click)="gethelp()" class="fw-bold text-secondary"
                  >Get Help?</a
                >
                instead.
              </div>
              <!-- END Access Denied Error -->

              <!-- Login form start -->
              <form
                id="login_form"
                [formGroup]="loginForm"
                (ngSubmit)="submitLoginForm(loginForm)"
              >
                <!-- Log In Form Tittle -->
                <div class="mb-4">
                  <h1 class="login_title">Enter credentials for test</h1>
                </div>

                <!-- Profile Name Form Group -->
                <div class="form-group">
                  <label class="input-label" for="profileName"
                    >Profile Name</label
                  >
                  <input
                    type="text"
                    formControlName="username"
                    class="form-control form-control-lg"
                    name="username"
                    id="profileName"
                    #profileName
                    placeholder="Enter profile name"
                    tabindex="1"
                    autocomplete="off"
                  />

                  <!-- Login Profile Name error -->
                  <div
                    id="profileName-error"
                    class="invalid-feedback help-block"
                  >
                    <div
                      *ngIf="
                        loginFC['username'].touched || loginFC['username'].dirty
                      "
                    >
                      <ng-container
                        *ngIf="
                          loginFC['username'].value === '' ||
                            loginFC['username'].value === null;
                          else fnInvalid
                        "
                      >
                        Profile name can't be empty.
                      </ng-container>

                      <ng-template #fnInvalid>
                        <span *ngIf="loginFC['username'].errors">
                          Please enter a valid profile name.
                        </span>
                      </ng-template>
                    </div>
                  </div>
                  <!-- End Login Profile Name error -->
                </div>
                <!-- End Profile Name Form Group -->

                <!-- Project Id -->
                <div class="form-group">
                  <label class="input-label" for="projectid">Project Id</label>
                  <input
                    class="form-control form-control-lg"
                    id="projectid"
                    type="text"
                    tabindex="2"
                    placeholder="Enter project id"
                    formControlName="projectid"
                  />
                  <!-- Project Id Validation -->
                  <div class="invalid-feedback help-block">
                    <div
                      *ngIf="
                        loginFC['projectid'].touched ||
                        loginFC['projectid'].dirty
                      "
                    >
                      <ng-container
                        *ngIf="
                          loginFC['projectid'].value === '' ||
                          loginFC['projectid'].value === null
                        "
                      >
                        Project id can't be empty.
                      </ng-container>
                    </div>
                  </div>
                  <!-- END Project Id Validation -->
                </div>
                <!-- End Project Id -->

                <!-- Token -->
                <div class="form-group">
                  <label class="input-label" for="token">Token</label>
                  <input
                    class="form-control form-control-lg"
                    id="token"
                    type="text"
                    tabindex="3"
                    placeholder="Enter token"
                    formControlName="token"
                  />
                  <!-- Token Validation -->
                  <div class="invalid-feedback help-block">
                    <div
                      *ngIf="loginFC['token'].touched || loginFC['token'].dirty"
                    >
                      <ng-container
                        *ngIf="
                          loginFC['token'].value === '' ||
                          loginFC['token'].value === null
                        "
                      >
                        Token field can't be empty.
                      </ng-container>
                    </div>
                  </div>
                  <!-- END Token Validation -->
                </div>
                <!-- End Token -->

                <!-- Audio/Video Call -->
                <div class="form-group">
                  <label class="input-label" for="token">Select Type</label>
                  <div
                    class="d-flex justify-content-between gap-2 login_radio_opt"
                  >
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="audio"
                        name="callType"
                        id="audioCall"
                        tabindex="4"
                        formControlName="callType"
                        checked
                      />
                      <label class="form-check-label" for="audioCall"
                        >Audio Call</label
                      >
                    </div>

                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="video"
                        name="callType"
                        id="videoCall"
                        tabindex="5"
                        formControlName="callType"
                      />
                      <label class="form-check-label" for="videoCall"
                        >Video Call</label
                      >
                    </div>
                  </div>
                </div>
                <!-- End Audio/Video Call -->

                <button
                  type="submit"
                  tabindex="6"
                  class="btn btn-lg btn-primary btn-block"
                  [ngStyle]="{
                    cursor:
                      loginForm.status !== 'VALID' ? 'not-allowed' : 'pointer'
                  }"
                  [disabled]="loginForm.invalid"
                >
                  LOGIN
                </button>
              </form>
            </ng-template>
            <!-- END Show Project ID and Token based Login -->
          </div>

          <!-- <div class="powered_by text-center mt-6">
            <p>
              Powered by
              <img
                class="img-fluid w-20 ms-2"
                src="assets/images/powered_by.svg"
                alt="Powered by logo"
              />
            </p>
          </div> -->
        </div>
      </div>
      <!-- END Login Right Side -->
    </div>
    <!-- End Row -->
  </div>
  <!-- End Content -->
</div>
<!-- ========== END MAIN CONTENT ========== -->
